import { render } from "./TiepaiManagement.vue?vue&type=template&id=ee575af0&scoped=true"
import script from "./TiepaiManagement.vue?vue&type=script&lang=js"
export * from "./TiepaiManagement.vue?vue&type=script&lang=js"

import "./TiepaiManagement.vue?vue&type=style&index=0&id=ee575af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee575af0"]])

export default __exports__